/**
 * Подписывается на приватный канал уведомлений, обновляет количество уведомлений в шапке
 */

import { updateNotificationsCount } from "../../../../components/notifications/update-count";



const subscriber = (rt) => {
  rt.subscribePrivate("alerts", data => {
    console.log('alerts', rt)
    if (data.notificationsCount) { 
      let count = parseInt(data.notificationsCount);
      window.notificationsCount = count;

      if (count > 0) {
        updateNotificationsCount(count); 
      }
    }
  });
}

export default subscriber;